module.exports = __webpack_public_path__ + "img/sld_aux_transformer_v_dark.aca7bf85.svg";